var recaptchaScriptLoaded   = false;
var recaptchaAjaxReady      = false;

var recaptchaOnload  = function(){
    recaptchaScriptLoaded = true;
    recaptchaRender();
};

var recaptchaRender = function() {
    if (recaptchaScriptLoaded && recaptchaAjaxReady){
        grecaptcha.render('grecaptcha', {
            'sitekey'   : '6LdumXAUAAAAAD2Ns1oDaGBUUyg_C0RQ4EnkquFM',
            'callback'  : function(response) {
                Subscription.settings.responseCaptcha=response;
                $("#login-cacha").html('Enviar').prop('disabled', false);
            }
        });
    }
};

var Subscription = {
    settings: {
        urlApi: urlApi,
        urlApiAllowed: urlApiAllowed,
        urlAssets: urlAssets,
        subscription_enabled: subscriptionEnabled,
        urlEnrich: urlEnrich,
        elementAppend: '#frameVideo',
        cookieSigned: 'subscribed',
        wishedVideo: wishedVideo,
        cookieMsisdn: 'msisdn',
        cookieMsisdnTemp: 'msisdn_temp',
        cookieMsisdnFormated: 'msisdn_formated',
        cookieCarrierCode: 'carrier_code',
        cookieCarrierName: 'carrier_name',
        cookieProducSigned: 'product_signed',
        cookieNet3gRequest: 'veryfy3g',
        cookieNet3gRequestWait: 'net3gRequestWait',
        cookieNet3g: '3g',
        carrierNames: {123:'Oi', 130:'Tim', 200:'Claro', 250:'Vivo'},
        productCode: productCode,
        partnerCode: partnerCode,
        currentUrl: currentUrl,
        priceInfo: priceInfo,
        responseCaptcha : null,
        tokenBifrost    : null,
        country    : null,
        partnerBifrost    : null,
        urlBifrost    : null,


    },
    init: function(){
        console.log(arguments.callee.name);
        Subscription.showLoader();
        Subscription.initSettings();
        if(Subscription.isAutenticatedLocal()){
            Subscription.isAllowed($.cookie(Subscription.settings.cookieMsisdn));
        }else{
            Subscription.enrich();
        }


    },
    showLoader: function(){
        console.log(arguments.callee.name);
        $("#loader").fadeIn('fast');
    },
    closeLoader:function(){
        console.log(arguments.callee.name);
        $("#loader").fadeOut('slow');
    },
    initSettings: function(){
        console.log(arguments.callee.name);
        settings = this.settings;
    },
    isAutenticatedLocal: function(){
        console.log(arguments.callee.name);
        if($.cookie(Subscription.settings.cookieSigned)=="true" && $.cookie(Subscription.settings.cookieMsisdn)){
            return true;
        }
        return false;
    },
    enrich: function(){
        console.log(arguments.callee.name);
        if (!$.cookie(Subscription.settings.cookieNet3gRequest)) {
            $.ajax({
                url: Subscription.settings.urlEnrich,
                method: 'GET',
                async: true,
                success: function (data) {
                    var res = JSON.parse(data);
                    $.cookie(Subscription.settings.cookieNet3gRequest, true, { expires: 1, path: '/' });
                    if (res.carrier) {
                        $.cookie(Subscription.settings.cookieNet3g, true, { expires: 1, path: '/' });
                        $.cookie(Subscription.settings.cookieMsisdn, res.msisdn, { expires: 1, path: '/' });
                        $.cookie(Subscription.settings.cookieCarrierCode, res.carrier_code, { expires: 1, path: '/' });
                        $.cookie(Subscription.settings.cookieCarrierName, Subscription.settings.carrierNames[res.carrier_code], { expires: 1, path: '/' });
                    }
                    Subscription.showLogon();
                },
                error: function () {
                    Subscription.showLogon();
                }
            });
        } else {
            Subscription.showLogon();
        }
    },
    saveLocalData: function (data) {
        console.log(arguments.callee.name);
        $.cookie(Subscription.settings.cookieSigned, data.status, { expires: 1, path: '/' });
        $.cookie(Subscription.settings.cookieMsisdn, data.msisdn, { expires: 1, path: '/' });
        $.cookie(Subscription.settings.cookieMsisdnFormated, data.msisdn_formated, { expires: 1, path: '/' });
        $.cookie(Subscription.settings.cookieCarrierCode, data.carrier_code, { expires: 1, path: '/' });
        $.removeCookie(Subscription.settings.cookieMsisdnTemp, { path: '/' });
    },
    showLogon: function (msisdn) {
        console.log(arguments.callee.name);
        var modalForm = '<section id="vdForms" class="formsLogin">'+
            '<div class="login ">'+
            '<div class="box-login text-center">'+
            '<p>Informe o número do seu celular para assistir esse e outros Vídeos</p>'+
            '<form id="form_login" onsubmit="return  Subscription.submitLogon();">'+
            '<input class="logonModalFormInput" type="hidden" name="from" id="from" value="login">'+
            '<div id="margin-tel">'+
            '<input name="telefone" type="text" id="telefone" placeholder="Telefone">'+
            '</div>'+
            '<div class="g-recaptcha" id="grecaptcha" style="margin: 10px auto;width: 302px;"></div>'+
            '<button type="submit" id="login-cacha" class="btn btn-warning" value="Entrar" disabled>Entrar</button>'+
            '<p>Milhares de Vídeos - Sem Publicidade</p>'+
            '</form>'+
            '</div>'+
            '</div>'+
            '</section>';

        $(Subscription.settings.elementAppend).html(modalForm);
        msisdn = (msisdn ? msisdn : ($.cookie(Subscription.settings.cookieMsisdn) ? $.cookie(Subscription.settings.cookieMsisdn) : undefined))
        if(msisdn){
            $("#telefone").val(msisdn.substring(2));
        }
        $("#telefone").mask("(99)99999-9999");

        recaptchaAjaxReady = true;
        recaptchaRender();
        Subscription.closeLoader();

    },
    submitLogon:function(){
        console.log(arguments.callee.name);
        var msisdn = $('#telefone').val().replace(/[^0-9\.]+/g, '');
        if (!msisdn) {
            sweetAlert("", "Informe o número corretamente", "error");
            return false;
        }
        Subscription.isAllowed('55'+msisdn);
        return false;
    },
    totalisAllowed: 0,
    timeOutisAllowed: null,
    stopisAllowed: function () {
        clearTimeout(Subscription.timeOutisAllowed);
    },
    isAllowed: function (msisdn, avoidPlay, playVideo, playStreaming) {
        console.log(arguments.callee.name);
        Subscription.showLoader();
        $.ajax({
            url: Subscription.settings.urlApiAllowed+'/'+msisdn,
            method: 'GET',
            async: true,
            success: function (data) {
                if (data.status) {
                    Subscription.saveLocalData(data);
                    if(!avoidPlay || playVideo){
                        /*Não Está na tela de autenticacao não deve executar o player*/
                        Subscription.showVideo();
                        Subscription.stopisAllowed();
                        sweetAlert.close();

                    }

/*                    ESTOU AQUI */
/*                    if(!playVideo && playStreaming){
                        return true
                    }*/
                }else {
                    if(avoidPlay){
                        /*Está na tela de autenticacao não deve prosseguir com a assinatura*/
                        return false;
                    }

                    if(data.is_carrier_valid==false){
                        sweetAlert("", "O telefone informado é inválido, verifique.", "error");
                        Subscription.closeLoader();
                    }else{
                        if(Subscription.isAutenticatedLocal()){
                            $.cookie(Subscription.settings.cookieSigned, false, { expires: 1, path: '/' });
                            Subscription.showLogon();
                            return;
                        }

                        $.cookie(Subscription.settings.cookieMsisdn, msisdn, { expires: 1, path: '/' });
                        $.cookie(Subscription.settings.cookieCarrierCode, data.carrier_code, { expires: 1, path: '/' });
                        $.cookie(Subscription.settings.cookieCarrierName, Subscription.settings.carrierNames[data.carrier_code], { expires: 1, path: '/' });
                        Subscription.openSubscription(data.carrier_code, $.cookie(Subscription.settings.cookieNet3g));
                    }
                }
            },
            error:function(){
                sweetAlert("", "Error get information [Allowed]", "error");
                Subscription.closeLoader();
            }
        });

        if(Subscription.totalisAllowed>0 && Subscription.totalisAllowed>=120){
            Subscription.stopisAllowed();
        }

    },

    addView: function () {
        $.ajax({
            url: urlOrigin+'/video/view/' + $.cookie(Subscription.settings.cookieMsisdn) + '/' + $.cookie(Subscription.settings.cookieCarrierCode) + '/' + Subscription.settings.wishedVideo,
            method: "GET",
            data: {
                '_token': token
            },
            success: function (data) {
                console.log(data);
            },
            error: function () {
                console.log('Erro salvando visualizações do vídeo');
            }
        });
    },

    showVideo: function () {
        console.log(arguments.callee.name);
        if(!Subscription.isAutenticatedLocal()){
            sweetAlert("", "Não foi possível carregar o vídeo, recarregue a página e tente  novamente.", "error");
            return false;
        }
        var matches = videoLink.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        var domain = matches && matches[1];
        var width  = $(Subscription.settings.elementAppend).width();
        if(domain==="player.mais.uol.com.br"){
            var video = document.createElement('iframe');
            video.id="player";
            video.width=width;
            video.height=width/1.8;
            video.src=videoLink;
            video.frameBorder='0';
            $(Subscription.settings.elementAppend).html(video);
            Subscription.addView();
        }else{
            var str = videoLink;
            var n = str.includes("m3u8");
            if(n){
                console.log('Ao Vivo');
                $('#video').empty();
                $('#video').html(`
                                           <div class="col-md-8">
                                                <div id="loader" style="width: 100%;height: 100%;position: fixed;opacity: 0.6;background: rgb(0, 0, 0);z-index: 99999;display: none;top: 0;left: 0;">
                                                    <div id="loading"></div>
                                                </div>
                                                <div class="player-img text-center video center-block"  id="frameVideo">
                                                    <video  id="video-player" class="video-js vjs-default-skin vjs-big-play-centered"  controls  loop preload="auto">
                                                        <source src="/stream/index.m3u8" type="application/x-mpegURL">
                                                    </video>
                                                </div>
                                          </div>
                                          <div class="col-md-4">
                                            <iframe src="https://minnit.chat/SexyPrive?embed&&nickname=" style="border:none;width:100%;height:480px;" allowTransparency="true"></iframe>
                                          </div>
                                        
                                   `);

                var player = videojs('video-player', {});
            }else {
                var video = document.createElement('video');
                video.className = "video-js";
                video.id = "player";
                video.poster = previewLink;
                video.controls = true;
                video.width = width;
                video.height = width / 1.8;
                var mp4 = document.createElement("source");
                mp4.type = "video/mp4";
                mp4.src = videoLink;
                video.appendChild(mp4);
                $(Subscription.settings.elementAppend).html(video);
                var player = videojs('player');
                /* VideoJS event */
                player.on("play", myfun);

                function myfun() {
                    if (!played) {
                        console.log('play');
                        played = true;
                        Subscription.addView();
                    }
                }
            }
        }

        Subscription.closeLoader();
    },
    getResultIframe:function () {
        console.log(arguments.callee.name);
        window.addEventListener("message", function(event) {

            var result = JSON.parse(event.data);
            console.log(result);
            if(Number(result.errorCode)==0){
                dataLocal                        = {};
                dataLocal.status                 = true;
                dataLocal.msisdn                 = $.cookie(Subscription.settings.cookieMsisdn);
                dataLocal.cookieMsisdnFormated   = $.cookie(Subscription.settings.cookieMsisdn);
                dataLocal.cookieCarrierCode      = $.cookie(Subscription.settings.cookieCarrierCode);
                Subscription.saveLocalData(dataLocal);
                Subscription.showVideo();
            }else{
                sweetAlert(result.errorCode, "Estamos tendo dificuldades para processar sua assinatura. Fique tranquilo e tente novamente mais tarde. :)", "error");
            }
        });
    },
    openSubscription:function (carrier, is3g) {
        console.log(arguments.callee.name);
        is3g            =  is3g ? "3G" : "WIFI";
        var nameFunction= 'open'+is3g+Subscription.settings.carrierNames[carrier];
        Subscription.showLoader();
        setTimeout("Subscription."+nameFunction+"()", 1 );

    },
    confirm3GOi:function () {
        console.log(arguments.callee.name);

    },
    open3GOi:function () {

    },
    open3GTim:function () {
        console.log(arguments.callee.name);
        Subscription.closeLoader();
        var tim3GCheck = '<section id="vdForms" class="formsLogin" style="height:400px;position: relative">'+
            '<div class="login ">'+
            '<div class="box-login text-center" style="top:30px;">'+
            '<p>Milhares de Vídeos a qualquer hora e em qualquer lugar!</p>'+
            '<input style="min-width: 24px;max-width: 45px;position: relative;top: 80px;right: 130px;" type="checkbox" id="checkInputTim">'+
            '<p class="infoAssinatura">Ao Clicar em ASSINAR você aceita os Termos e condições do serviço e confirma sua assinatura no valor de R$: 2.99 por semana com renovação automática.</p>'+
            '<button type="submit" class="btn btn-warning" onclick="Subscription.validate3gTim()" value="Entrar">ASSINAR R$ 2.99 POR SEMANA</button>'+
            '</div>'+
            '</div>'+
            '</section>';
        $(Subscription.settings.elementAppend).html(tim3GCheck);
        $('#frameVideo').css('z-index', 19000);

    },
    validate3gTim:function () {
        console.log(arguments.callee.name);
        if (jQuery("#checkInputTim").is(":checked")) {
            Subscription.showLoader();
            Subscription.getIframeTim();
        }else{
            sweetAlert("", "Você deve aceitar os termos e condições", "error");
        }
    },
    open3GClaro:function () {
        console.log(arguments.callee.name);
        Subscription.getTokenBifrost();
    },
    openWIFIClaro:function () {
        console.log(arguments.callee.name);
        Subscription.getTokenBifrost();
    },
    open3GVivo:function () {
        console.log(arguments.callee.name);
        Subscription.getTokenBifrost();
    },
    validate3gVivo:function () {
        weetAlert("", "Operadora Vivo não disponível", "info");
    },
    openWIFIOi:function () {
        weetAlert("", "Operadora Oi não disponível", "info");
    },
    openWIFITim:function () {
        console.log(arguments.callee.name);
        Subscription.getIframeTim();
    },

    openWIFIVivo:function () {
        console.log(arguments.callee.name);
        Subscription.getTokenBifrost();
    },

    getIframeTim:function () {
        console.log(arguments.callee.name);
        $.ajax({
            url         : Subscription.settings.urlApi+'/vascore/product/code/'+Subscription.settings.productCode+'/carrier/'+$.cookie(Subscription.settings.cookieCarrierCode),
            method      : "GET",
            data        : {},
            success: function (data) {
                console.log(data);
                if(data[0] && data[0].id!=0){
                    Subscription.getIframeTrackerTim(data[0].tim_aplication_id, $.cookie(Subscription.settings.cookieMsisdn));
                    Subscription.appendIframeTim('https://auth3.tim.com.br/v2/accesscontrol-web/contractiframe?embedded=true&paymentType=2&client_id='+data[0].tim_client_id+'&redirect_uri=https://tracki.me/subscription/tim/oauth-callback&scope=TIM.servico&appid='+data[0].tim_aplication_id+'&csp='+ data[0].tim_csp+'&mode=iframe&msisdn='+$.cookie(Subscription.settings.cookieMsisdn).substring(2), data[0].tim_aplication_id, $.cookie(Subscription.settings.cookieMsisdn));

                }else{
                    sweetAlert("", "Error Requisitando Tim", "error");
                }
            }
        });

    },
    getIframeTrackerTim: function(timAppId, msisdn) {
        var hash = window.btoa(msisdn+'/0/0/0/'+Subscription.settings.currentUrl);
        var trackerCookie = 'https://tracki.me/subscription/tim/iframe?subId=0000&applicationId='+timAppId+'&msisdn='+msisdn+'&hashPrimetube='+hash+'&redirectUrl='+window.location.href;
        $('#iframeTrackerTim').attr('src', trackerCookie);
    },
    appendIframeTim : function (url) {
        var ifr=$('<iframe/>', {
            id:'iframeTim',
            src:url,
            height:"100%",
            style:'width:100%;background: #fff center center no-repeat;min-height:350px',
            frameborder:"0",
            scrolling:"yes",
            allowfullscreen:true,
        }).on('load', function() {
            Subscription.closeLoader();
        });

        $(Subscription.settings.elementAppend).html(ifr);
        Subscription.getResultIframe();
    },
    getTokenBifrost: function() {
        var url = Subscription.settings.urlApi;
        $.ajax({
            url: url+'/api/get-token-bifrost-by-partner-code/'+Subscription.settings.partnerCode,
            data:{
                'msisdn'            : $.cookie(Subscription.settings.cookieMsisdn),
                'carrier'           : $.cookie(Subscription.settings.cookieCarrierCode)
            },
            method:'POST',
            success: function(result) {
                if(result.result_code==0 || result.result_code=='0'){
                    Subscription.settings.tokenBifrost      = result.token;
                    Subscription.settings.country           = result.country;
                    Subscription.settings.partnerBifrost    = result.partner_bifrost;
                    Subscription.settings.urlBifrost        = result.url_bifrost;
                    Subscription.settings.productCode       = result.product_code;
                    Subscription.getPinCode();
                }else{
                    sweetAlert("", 'Nao foi possível concluir sua solicitação ('+result.result_code+'). Tente novamente em alguns minutos.', "info");
                    Subscription.closeLoader();
                    return false;
                }
                Subscription.closeLoader();

            }
        });
    },
    getPinCode: function() {
        $.ajax({
            url: Subscription.settings.urlBifrost+'/api/request-pin',
            data:{
                'token'             : Subscription.settings.tokenBifrost,
                'country'           : Subscription.settings.country,
                'responseCaptcha'   : Subscription.settings.responseCaptcha

            },
            method:'POST',
            success: function(result) {
                Subscription.closeLoader();
                if(result.result_code=="0" || result.result_code==0){
                    var div = '<section id="vdForms" class="formsLogin">'+
                        '<div class="box-pin">'+
                        '<div class="text-center">'+
                        '<p>Foi enviada uma mensagem com código para seu celular. Insira-o no espaço abaixo para ter acesso ao conteúdo</p>'+
                        '<form id="code" action="" onsubmit="return Subscription.submitPinCode()">'+
                        '<div class="inputCode">'+
                        '<label>Código</label>'+
                        '<input name="code" type="number" id="codePin" placeholder="0000" data-placeholder="0000" max="9999">'+
                        '</div>'+
                        '<button type="submit" id="codeButton" class="btn btn-warning" value="Entrar">ASSINAR</button>'+
                        '<input class="check" type="checkbox" name="termos" value="termos" required="required">'+
                        '<p class="infoAssinatura">Ao Clicar em ASSINAR você aceita os Termos e condições do serviço e confirma sua assinatura no valor de '+Subscription.settings.priceInfo+' com renovação automática.</p>'+
                        '</form>'+
                        '</div>'+
                        '</div>'
                    '</section>';
                    $(Subscription.settings.elementAppend).html(div);
                }else{
                    sweetAlert("", 'Nao foi possível concluir sua solicitação ('+result.result_code+'). Tente novamente em alguns minutos.', "info");
                    return false;
                }
            }
        });
    },

    submitPinCode: function() {
        var pincode = $("#codePin").val();
        if (pincode == '' || pincode == null || pincode.length < 4) {
            sweetAlert("", 'Digite o pincode recebido', "info");
            return false;
        }
        return Subscription.sendPinCode(pincode);
    },

    sendPinCode: function(pin) {
        Subscription.showLoader();
        $.ajax({
            url: Subscription.settings.urlBifrost+'/api/send-pin',
            data:{
                msisdn          : $.cookie(Subscription.settings.cookieMsisdn),
                carrier         : $.cookie(Subscription.settings.cookieCarrierCode),
                product         : Subscription.settings.productCode,
                token           : Subscription.settings.tokenBifrost,
                country         : Subscription.settings.country,
                pin             : pin,
                responseCaptcha : Subscription.settings.responseCaptcha
            },
            method:'POST',
            success: function(result) {
                Subscription.closeLoader();
                if(result.result_code=="0" || result.result_code==0){
                    Subscription.timeOutisAllowed = setInterval(function(){
                        Subscription.totalisAllowed++;
                        Subscription.isAllowed($.cookie(Subscription.settings.cookieMsisdn), true, true);
                    }, 2000);

                    sweetAlert({
                        title: 'Aguarde',
                        type: 'success',
                        text: 'Finalizando autenticação com a sua operadora',
                        showCancelButton: false,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                    return false;
                }else{
                    sweetAlert("", result.result_message, "info");
                    Subscription.closeLoader();
                    return false;
                }
            }
        });

        return false;
    }

};
